/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Login.css';
import Particles from 'react-particles-js'
import Link from '../../components/Link'
import history from '../../history'
import particlesConfig from './particles.config'
import Logo from '../../components/Logo';
import { login, getPhoneCode } from '../../controller';

console.log('------------------');
class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      phone: '',
      password: '',
      isError: false,
      data: null,
      error: null,
      errTxt: '',
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.saveToState = this.saveToState.bind(this)
    this.valid = this.valid.bind(this)
  }

  /**
   * 监听input改变
   * @param {*} e 
   */
  saveToState (e) {
    const { name, value } = e.target
    this.setState({
      [name]: value,
      isError: false,
    })
  }

  /**
   * 验证手机号码
   * @param {*} e 
   */
  valid (e) {
    const formData = new FormData()
    formData.append('phone', this.state.phone)
    formData.append('type', '0')

    getPhoneCode(formData)
      .then(res => {
        if (res.err_msg != 'phone already exists') {
          this.setState({
            errTxt: '手机号未注册',
            isError: true
          })
        }
      })
  }

  /**
   * 登陆页面
   * @param {*} e 
   */
  handleSubmit(e) {
    e.preventDefault()
    const { phone, password } = this.state

    if (this.state.phone != '' && this.state.password != '') {
      const formData = new FormData()
      formData.append('account', phone)
      formData.append('pwd', password)
      
      login(formData)
        .then(res => {
          if (!res) return this.setState({
            isError: true,
            errTxt: '登陆失败',
          })

          this.setState({
            data: res,
            isError: true,
            errTxt: '账号或密码错误',
            error: res.err_msg
          })

          if (res.incomplete_results == false) {
            localStorage.setItem('user', `${res.name}`);
            localStorage.setItem('isLogin', `true`);
            localStorage.setItem('company', `${res.company}`)
            history.push('/')
          }
        })
        .catch (err => {
          this.setState({
            error: err.status
          })
        })
    } else {
      this.setState({ isError: true })
    }
  }

  render() {
    const particlesStyle = {
      position: "absolute",
      width: "100%",
      height: "100%"
    }

    const { errTxt } = this.state
    return (
      <div className={s.root}>
        <div className={s.bg}>
          <Particles params={particlesConfig} style={particlesStyle} />
        </div>
        <div className={s.loginbox}>
          <Logo className={s.logo} />
          <div className={s.loginform}>
            <form action="" method="post" onSubmit={this.handleSubmit}>

              <ul>
                <li>
                  <input type="text"
                    value={this.state.phone}
                    placeholder="手机"
                    name='phone'
                    onChange={this.saveToState}
                  />
                  <i></i>
                </li>
                <li>
                  <input type="password"
                    value={this.state.password}
                    placeholder="请输入密码"
                    name='password'
                    onChange={this.saveToState}
                    onBlur={this.valid}
                  />
                  <i></i>
                </li>
              </ul>
              <span className={this.state.isError ? s.error : s.hide} >{errTxt}</span>

              <span>
                <Link to='/forgetpwd'>找回密码</Link>
              </span>
              <button className={s.loginBtn} type="submit"> 登陆 </button>
            </form>
            <span>没有账号？马上<Link to='/register'>注册</Link>
            </span>
          </div>

        </div>
      </div>
    );
  }
}

export default withStyles(s)(Login);



// WEBPACK FOOTER //
// src/routes/login/Login.js